<div class="body">

  <div class="center-wrapper">
    <div class="center-content">

      <div *ngIf="!isApiCall && !redirect"
           style="display: flex; flex-direction: column; justify-content: center; align-items: center; min-height: 80vh; text-align: center;">
        <div class="spinner-border text-primary mb-3" role="status" style="width: 3rem; height: 3rem;">
          <span class="sr-only">Loading...</span>
        </div>
        <h4 class="pt-3">
          {{ msg }}
        </h4>
      </div>


      <div *ngIf="isApiCall && !redirect">

        <!-- Header Logo -->
        <div class="payment-card-header">
          <div class="d-flex ">
            <div>
              <small class="amount-text">eReturn</small><br>
              <small>etaxnbr.gov.bd</small>
            </div>
            <div class="ml-auto logo-text">
              <img src="assets/img/images/logo.png" class="img-fluid">
            </div>
          </div>
        </div>

        <div class="payment-card">

          <!-- failed payment -->
          <div *ngIf="!isSuccess">
            <div class="success-icon ">
              <img src="assets/img/images/Group.png" alt="success" class="success-svg mb-2">
            </div>
            <h4 class="text-center font-weight-bold mt-4">Payment Failed</h4>
            <p class="text-center text-muted"> {{ msg }}</p>
          </div>

          <!-- successful payment -->
          <div *ngIf="isSuccess">
            <div class="success-icon ">
              <img src="assets/img/images/Vector.svg" alt="success" class="success-svg mb-2">
            </div>
            <h4 class="text-center font-weight-bold mt-4">Payment Successful</h4>
            <p class="text-center text-muted"> {{ msg }}</p>
            <hr>
            <div class="row mb-2">
              <div class="col-6 text-muted">Challan No</div>
              <div class="col-6  font-weight-bold">
                {{ challanResponse?.challanNo ? challanResponse?.challanNo : 'N/A' }}
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-6 text-muted">Challan Slip</div>
              <div class="col-6">
                <b *ngIf="challanResponse?.challanSlipUrl; else noChallan">
                  <a [href]="challanResponse?.challanSlipUrl" target="_blank">View Challan</a>
                </b>
                <ng-template #noChallan>
                  <b>N/A</b>
                </ng-template>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-6 text-muted">Payment Gateway</div>
              <div class="col-6  font-weight-bold">{{ challanResponse?.paymentMethod || '—' }}</div>
            </div>
            <div class="d-flex bd-highlight amount-box">
              <div class="p-3 flex-fill bd-highlight amount-lebel ">Amount</div>
              <div class="p-3 flex-fill bd-highlight amount-text ">
                ৳ {{ challanResponse?.amount | currencySeparatorBD }}
              </div>
            </div>
          </div>
          <hr>


          <!-- Redirect -->
          <button type="button" class="btn-custom btn-block"
                  (click)="redirectTaxAndPayment()">
            <svg style="font-size: 20px;vertical-align: sub" width="1em" height="1em" viewBox="0 0 16 16"
                 class="bi bi-arrow-right arrowSaveContinue" fill="currentColor"
                 xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd"
                    d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"/>
            </svg>
            Go to Tax & Payment Page
          </button>

        </div>
      </div>

      <div *ngIf="redirect"
           style="display: flex; flex-direction: column; justify-content: center; align-items: center; min-height: 80vh; text-align: center;">
        <div class="spinner-border text-primary mb-3" role="status" style="width: 3rem; height: 3rem;">
          <span class="sr-only">Loading...</span>
        </div>
        <h4 class="pt-3">
          {{ msg }}
        </h4>
      </div>

    </div>


  </div>
</div>

